module.exports = __webpack_public_path__ + "img/Over_the_limit.62996193.jpg";